import React from 'react'
import styled from 'styled-components'

const Contact = () => {
  return (
    <Wrapper>
      <section className='section-center'>
        <h3>join our new setller and get 20% off</h3>
        <section className='content'>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam
            quis minus alias illo, velit possimus dolores ullam quasi adipisci?
            Dolorum iure quidem asperiores possimus amet corrupti sit
            voluptatibus quas quasi.
          </p>
          <form className='contact-form'>
            <input
              type='email'
              className='contact-input'
              placeholder='join now'
            />
            <button type='submit' className='submit-btn'>
              submit
            </button>
          </form>
        </section>
      </section>
    </Wrapper>
  )
}
const Wrapper = styled.section`
  margin: 5rem 0;
  h3 {
    text-transform: none;
  }
  p {
    line-height: 2;
    max-width: 45em;
    color: var(--clr-grey-5);
  }
  .contact-form {
    width: 90vw;
    max-width: 500px;
    display: grid;
    grid-template-columns: 1fr auto;
  }
  .contact-input,
  .submit-btn {
    font-size: 1rem;
    padding: 0.5rem 1rem;
    border: 2px solid var(--clr-black);
  }
  .contact-input {
    border-right: none;
    color: var(--clr-grey-3);
    border-top-left-radius: var(--radius);
    border-bottom-left-radius: var(--radius);
  }
  .submit-btn {
    border-top-right-radius: var(--radius);
    border-bottom-right-radius: var(--radius);
    background: var(--clr-primary-5);
    text-transform: capitalize;
    letter-spacing: var(--spacing);
    cursor: pointer;
    transition: var(--transition);
    color: var(--clr-black);
  }
  .contact-input::placeholder {
    color: var(--clr-black);
    text-transform: capitalize;
  }
  .submit-btn:hover {
    color: var(--clr-white);
  }
  @media (min-width: 992px) {
    .content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: center;
      gap: 8rem;
      margin-top: 2rem;
    }
    p {
      margin-bottom: 0;
    }
  }
  @media (min-width: 1280px) {
    padding: 15rem 0;
  }
`
export default Contact
